// https://github.com/danielsogl/awesome-cordova-plugins/issues/505#issuecomment-1514923940
(window as any).__Zone_disable_FileReader = true;
